import wrappedFetch from './base';

export const getWebPushSubscriptions = () => {
  return wrappedFetch('/web_push_subscribers.json')
    .then((response) => response.json());
};

export const deleteWebPushSubscription = (webPushSubscriberId) => {
  const config = {
    method: 'DELETE',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
  };

  return wrappedFetch(`/web_push_subscribers/${webPushSubscriberId}.json`, config);
};

export const triggerWebPushNotification = (webPushSubscriberId) => {
  const config = {
    method: 'GET',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
  };

  return wrappedFetch(`/web_push_subscribers/trigger_web_push_notification.json?user_id=${webPushSubscriberId}`, config);
};
